import React from 'react'
import { utitService } from '../../../services/util';
const DateColumn = (rowData, options) => {
    const field = options.field || 'startDate';
    if (!rowData[field]) return <span className="date-text">-</span>;
    if (field === 'endDate' && rowData.endDate) {
        return (
            <span className="date-text">
                {utitService.dateParser(rowData.endDate, 'ddd DD-MM-YYYY')}
            </span>
        );
    } else if (field === 'startDate' && rowData.startDate) {
        return <span className="date-text">{utitService.dateParser(rowData.startDate, 'ddd DD-MM-YYYY')}</span>;
    }
}

export default DateColumn;